// utils/externalFetcher.js
export const externalFetcher = async (url) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error("External API error");
  return await res.text(); // or res.text() depending on content-type
};
